import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Landing from '../pages/Landing';

/**
 * ProtectedRoute — gates authed-only UI.
 *
 * For unauthenticated visitors:
 *   - At `/` on any domain (juuniai.com apex, www.juuniai.com, tenant
 *     subdomains like deltra.juuniai.com, localhost, vercel previews)
 *     → render the public marketing Landing page. Stripe / Google /
 *     prospects need a public homepage before they sign in, and we
 *     want the marketing surface consistent across every host.
 *   - Any other protected path → redirect to /login.
 *
 * Previous behavior (pre-2026-04-20): tenant subdomains redirected
 * straight to /login. That was reversed because the landing carries
 * the Juuni brand identity we want visible on every customer-facing
 * host. Tenant staff who know where they're going still click "Sign
 * in" from the nav; the cost of that one extra click is small vs.
 * the brand value of a consistent homepage.
 */
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: '#F3F4F6',
        fontFamily: 'var(--font-mono)',
        fontSize: 13,
        color: '#999',
        letterSpacing: '0.05em'
      }}>
        LOADING...
      </div>
    );
  }

  if (!user) {
    const isRootPath = location.pathname === '/' || location.pathname === '';
    if (isRootPath) {
      return <Landing />;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
}
